import React from 'react';
import styled from 'styled-components';
import Section from './shared/Section';
import { Paragraph } from './shared/Basics.js';

/* The actual timeline (the vertical ruler) */
const Timeline = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 50px auto 20px auto;
`;

const TimelineTitle = styled.div`
  position: relative;
  margin-bottom: 40px;
  left: 20%;
  width: 55%;
`;

/* Container around content */
const TimelineEvent = styled.div`
  padding: 0px 40px 40px 40px;
  position: relative;
  background-color: inherit;
  left: 20%;
  width: 55%;

  &:not(:last-child) {
    border-left: 3px solid #999;
  }

  &:last-child {
    border-left: 3px solid #fff;
  }

  &::after {
    content: '';
    position: absolute;
    width: 25px;
    height: 25px;
    left: -18px;
    background-color: white;
    border: 4px solid #d1caf4;
    top: -10px;
    border-radius: 50%;
    z-index: 1;
  }
`;

/* The actual content */
const EventContentWrapper = styled.div`
  background-color: white;
  position: relative;
`;

const EventTitle = styled.div`
  font-weight: bold;
`;

const EventTime = styled.div`
  margin-bottom: 16px;
`;

const EventBody = styled.div`
`;

const TimelineSection = (props) => {
  return (
    <TimelineEvent>
      <EventContentWrapper>
        <EventTitle>
          {props.title}
        </EventTitle>
        <EventTime>
          {props.time}
        </EventTime>
        <EventBody>
          {props.children}
        </EventBody>
      </EventContentWrapper>
    </TimelineEvent>
  );
}


const Events = () => {
  return (
    <Section title='Events' id='events'>
      <Paragraph>Here's what we have planned for the evening.</Paragraph>
      <Timeline>
        <TimelineTitle>Sunday September 26th, 2021</TimelineTitle>
        <TimelineSection title='Guests Arrive at Casa Real' time='4:00pm'>
        </TimelineSection>
        <TimelineSection title='Our Ceremony' time='4:30pm'>
          The ceremony will begin promptly at 4:30pm.
        </TimelineSection>
        <TimelineSection title='Cocktail Hour' time='5:00pm'>
          Enjoy socializing with games, drinks, and appetizers.
        </TimelineSection>
        <TimelineSection title='Tea Ceremony' time='5:15pm - 5:45pm'>
          A traditional event reserved for the family of the bride and groom.
        </TimelineSection>
        <TimelineSection title='Reception' time='6pm'>
          Enjoy a three course dinner.
        </TimelineSection>
        <TimelineSection title='Toasts and Cake Cutting' time=''>
          The cake is very "us".
        </TimelineSection>
        <TimelineSection title='Dancing and Late Night Treats' time='8:30pm'>
          Enjoy the evening! <br /> (There will be boba and nachos.)
        </TimelineSection>
        <TimelineSection title='Bride and Groom Sendoff' time='10:00pm'>
        </TimelineSection>
      </Timeline>
    </Section>
  );
}

export default Events;
